import styled from 'styled-components';

export const SummaryBox = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.bgMuted};
  border-radius: ${({ theme }) => theme.radii.md};
  margin-bottom: ${({ theme }) => theme.spacing[5]};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LabelBadge = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  padding: 0.125rem 0.5rem;
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: ${({ theme }) => theme.colors.gray200};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LabelsRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 70vh;
  border: none;
  border-radius: ${({ theme }) => theme.radii.md};
`;

export const DocxContainer = styled.div`
  max-height: 70vh;
  overflow: auto;
  border-radius: ${({ theme }) => theme.radii.md};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  -webkit-overflow-scrolling: touch;

  .docx-wrapper {
    background: white;
    padding: 1rem;
  }

  @media (max-width: 767.98px) {
    max-height: 60vh;

    .docx-wrapper {
      padding: 0.5rem;
      transform-origin: top left;
      min-width: 0;
    }

    .docx-wrapper > section {
      max-width: 100% !important;
      width: 100% !important;
      padding: 0.5rem !important;
      min-height: auto !important;
    }
  }
`;

export const RtfContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  border-radius: ${({ theme }) => theme.radii.md};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  padding: ${({ theme }) => theme.spacing[4]};
  background: white;
`;

export const CenteredSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`;

export const NameEditWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};

  .form-control {
    max-width: 400px;
  }
`;

export const ImportSourceIcon = styled.span`
  display: inline-flex;
  align-items: center;
  opacity: 0.6;
`;

export const BreakAll = styled.span`
  word-break: break-all;
`;

export { HiddenFileInput } from '@/styles/shared.styled';
